import SessionStorage from "../session/SessionStorage";
import { ReadOnlyService } from "./ReadOnlyService";
import { Recipe } from "./RecipeService";


class ExternalProvider extends ReadOnlyService<Recipe> {
    private readonly name: string;
    constructor(name: string, sessions: SessionStorage) {
        super(`providers/${name}`, sessions);
        this.name = name;
    }

    random() {
        return new ExternalProvider(`${this.name}/random`, this.sessions);
    }

    lookup(id: string) {
        return new ExternalProvider(`${this.name}/${id}/recipes`, this.sessions);
    }
}

class ProviderService extends ReadOnlyService<Recipe> {
    constructor(sessions: SessionStorage) {
        super("providers", sessions);
    }

    provider(name: string) {
        return new ExternalProvider(name, this.sessions);
    }
}

export default ProviderService;